import React, { useState } from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import { profile } from '../data';
import '../styles/theme.css';

const contactLinks = [
  { icon: '✉', label: profile.email, sub: 'Email', href: `mailto:${profile.email}` },
 // { icon: 'in', label: profile.linkedinLabel, sub: 'LinkedIn', href: profile.linkedin },
  { icon: '☎', label: profile.phonePrimary, sub: 'Phone · Colombo, Sri Lanka', href: `tel:${profile.phonePrimary.replace(/\s/g, '')}` },
  { icon: '☎', label: profile.phoneSecondary, sub: 'Phone · Singapore', href: `tel:${profile.phoneSecondary.replace(/\s/g, '')}` },
];

function ContactLink({ icon, label, sub, href }) {
  return (
    <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer" className="contact__link">
      <div className="contact__icon">{icon}</div>
      <div>
        <div className="contact__label">{label}</div>
        <div className="contact__sub">{sub}</div>
      </div>
    </a>
  );
}

export default function Contact() {
  const fade = useFadeIn();

  return (
    <section id="contact" className="section">
      <SectionLabel>Contact</SectionLabel>
      <div ref={fade.ref} className="contact__card">
        <div>
          <h2 className="contact__heading">Let's Connect.</h2>
          <p className="contact__text">I'm open to Software Engineering opportunities, freelance collaborations, technical consultation, application deployment and hosting services. I also enjoy mentoring aspiring software engineers students through career guidance, resume reviews, interview preparation, and sharing practical insights from the industry. Whether you're looking to hire, collaborate, or learn, I'd be happy to connect.</p>
        </div>

        <div className="contact__list">
          {contactLinks.map(link => <ContactLink key={link.sub} {...link} />)}
        </div>
      </div>
    </section>
  );
}
